import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import axios from "axios";
import { Navbar, Footer, Sidebar, ThemeSettings } from "./Components";
import {
  Contact,
  Events,
  Faculty,
  Placement,
  Circular,
  Course,
  Gallery,
  Inquiry,
  Syllabus,
  Dashboard,
  Testimonial,
} from "./Pages";
import Login from "./Pages/Login"; // Assuming Login.jsx is in Pages folder
import "./App.css";

import { useStateContext } from "./Contexts/ContextProvider";
import { BaseUrlProvider } from "./Contexts/BaseUrlContext";
// import Testimonials from './Pages/Testimonial';

// Protected Route component to check authentication
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("authToken");
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const App = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }

    if (currentThemeMode === "Dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    console.log("App component mounted");
  }, []);

  return (
    <div className={currentMode === "Dark" ? "dark" : ""}>
      <BrowserRouter>
        <BaseUrlProvider>
          <div className="flex relative dark:bg-main-dark-bg">
            <div className="fixed right-4 bottom-4" style={{ zIndex: "1000" }}>
              <TooltipComponent content="Settings" position="Top">
                <button
                  type="button"
                  onClick={() => setThemeSettings(true)}
                  style={{ background: currentColor, borderRadius: "50%" }}
                  className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
                >
                  <FiSettings />
                </button>
              </TooltipComponent>
            </div>
            <Routes>
              {/* Login Route */}
              <Route path="/login" element={<Login />} />
              {/* All other routes are protected */}
              <Route
                path="/*"
                element={
                  <div
                    className="flex relative dark:bg-main-dark-bg"
                    style={{ width: "100%" }}
                  >
                    {activeMenu ? (
                      <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
                        <Sidebar />
                      </div>
                    ) : (
                      <div className="w-0 dark:bg-secondary-dark-bg">
                        <Sidebar />
                      </div>
                    )}
                    <div
                      className={
                        activeMenu
                          ? "dark:bg-main-dark-bg bg-main-bg min-h-screen md:ml-72 w-full"
                          : "bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2"
                      }
                    >
                      <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
                        <Navbar />
                      </div>
                      <div className="w-full">
                        {themeSettings && <ThemeSettings />}
                        <Routes>
                          {/* Dashboard */}
                          <Route path="/" element={<Contact />} />
                          <Route path="/dashboard" element={<Dashboard />} />
                          <Route path="/contact" element={<Contact />} />
                          <Route path="/inquiry" element={<Inquiry />} />
                          {/* Pages */}
                          <Route path="/faculty" element={<Faculty />} />
                          <Route path="/gallery" element={<Gallery />} />
                          <Route path="/circular" element={<Circular />} />
                          <Route path="/events" element={<Events />} />
                          <Route path="/course" element={<Course />} />
                          <Route path="/placement" element={<Placement />} />
                          <Route path="/syllabus" element={<Syllabus />} />

                          <Route
                            path="/testimonial"
                            element={<Testimonial />}
                          />
                        </Routes>
                      </div>
                      <Footer />
                    </div>
                  </div>
                }
              />
            </Routes>
          </div>
        </BaseUrlProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
